import React, { useContext, useEffect, useState } from "react";

import { graphql } from "gatsby";

import { Trans, useTranslation, useI18next } from "gatsby-plugin-react-i18next";

import { authContext } from "../contexts/authContext";

import Layout from "../components/Layout";
import Section from "../components/Section";
import Promo from "../components/Promo";
import LoginForm from "../components/LoginForm.js";

import appGoogleImg from "../images/appGoogle.jpg";
import appStoreImg from "../images/appStore.jpg";
import api from "../utils/api";
import { isRtlLanguage } from "../utils/rtl";

const Index = (props) => {
  const auth = useContext(authContext);
  const { t } = useTranslation();
  const { language } = useI18next();
  const isRtl = isRtlLanguage(language);
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = auth && auth.token;
  
  useEffect(() => {
    // If there is no token, we are not able to call the API.
    // Also ensure spinner does NOT get stuck.
    if (!token) {
      setLoading(false);
      setCoupon(null);
      return;
    }
  
    setLoading(true);
  
    api.getRecommenderCoupon(token, language)
      .then((res) => {
        if (!res || !res.coupon) {
          setCoupon(null);
          return;
        }
        setCoupon(res.coupon);
      })
      .catch((err) => {
        setCoupon(null);
      })
      .finally(() => setLoading(false));
  
  }, [token, language]);
  

  return (
    <Layout location={props.location}>
      <Section title={t("welcome_message")}>
        <div
          className={"flex flex-col text-sm max-w-4xl leading-5"}
          dangerouslySetInnerHTML={{ __html: t("welcome_section_content") }}
        />
      </Section>

      {auth.isLoggedIn ? (
        <Section title={t("recommender_code_title")}>
          <div className={"flex flex-col text-sm max-w-4xl leading-5 text-center"}>
            <div>
              <span dangerouslySetInnerHTML={{ __html: t("recommender_coupon") }} />

              <span className={`${isRtl ? "mr-2" : "ml-2"} inline-flex items-center min-w-[140px]`}>
                {loading && <span className="h-4 w-4 spinner" />}
                {!loading && coupon && (<span className="font-semibold leading-5">{coupon}</span>)}
              </span>

            </div>
            <div
              className={"mt-2 text-sm text-center"}
              dangerouslySetInnerHTML={{ __html: t("no_coupon_how_to_recommend") }}
            />
          </div>
        </Section>
      ) : (
        <Section title={t("login_title")}>
          <LoginForm />
          <div className="flex flex-col md:flex-row items-center justify-between border-t pt-8 mt-10 w-full text-sm">
            <p className={`max-w-sm text-center ${isRtl ? "md:text-right" : "md:text-left"}`}>
              <Trans>Dr Simeonsi dieedi tugikeskus mobiilirakendus on saadaval siin:</Trans>
            </p>
            <div className="flex">
              <a
                target={"_blank"}
                rel="noreferrer"
                href={"https://play.google.com/store/apps/details?id=com.shternconsulting.simeonsdiet.app"}
                className={`max-w-2xl w-full h-auto ${isRtl ? "ml-3" : "mr-3"}`}
              >
                <img src={appGoogleImg} alt="GooglePlay" />
              </a>
              <a
                target={"_blank"}
                rel="noreferrer"
                href={"https://apps.apple.com/us/app/dr-simeonsi-dieedi-tugikeskus/id1435077850?ls=1"}
                className="max-w-2xl w-full h-auto m-0"
              >
                <img src={appStoreImg} alt="AppStore" />
              </a>
            </div>
          </div>
        </Section>
      )}

      <Promo />
    </Layout>
  );
};

export default Index;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
